export const TEMPLATES_AMOUNT = '1000';
